const workflows = {
  workflow_history: `Historial de flujo de trabajo`,
  workflow_updated: `Flujo de trabajo actualizado`,
  new_workflow: `Nuevo flujo de trabajo`,
  old_workflow: `Antiguo flujo de trabajo`,
  workflow_change_logs: `Registros de cambios del flujo de trabajo`,
  assign_workflow: `Asignar flujo de trabajo`,
  assign_workflow_to_organization_users: `Asignar este flujo de trabajo de documento a los usuarios de su organización`,
  approvers: `Aprobadores`,
  add_a_new_email: `Añadir un nuevo correo electrónico`,
  assign: `Asignar`,
  workflow_doc_pending_approval: `Aprobación pendiente del documento de flujo de trabajo`,
  assign_supplier_to_organization_users: `Asignar proveedor a los usuarios de la organización`,
  workflow_doc_deleted: `Documento de flujo de trabajo eliminado`,
  workfow_doc_approvalnotrequired_attached: `Aprobación del documento de flujo de trabajo no requerida adjunta`,
  workflow_assigned_successfully: `Flujo de trabajo asignado con éxito`,
  workflow_doc_not_classified: `La clase de cuenta y una de las clases de documento de este documento no están clasificadas`,
  workflow_doc_purchase_requisition_id_missing: `Este documento de solicitud no tiene una solicitud de compra vinculada`,
  you_do_not_have_any_workflows_yet: `Aún no tienes ningún flujo de trabajo`,
  no_workflows_found_for_the_selected_filters: `No se encontraron flujos de trabajo para los filtros seleccionados`,
  approve: "Aprobar",
  reject: "Rechazar",
  approvalRequired: "Aprobación requerida",
  approved: "Aprobado",
  rejected: "Rechazado",
  reviewRequired: "Revisión requerida",
  pending_approval: `Aprobación pendiente`,
  approval_not_required: `Aprobación no requerida`,
  workflow_documents_pending_approval: `Documento de flujo de trabajo pendiente de aprobación`,
  approval_status: `Estado de aprobación`,
  workflow_details: `Detalles del flujo de trabajo`,
  workflow_docstatus_duplicate: `El flujo de trabajo no se puede asignar a un documento duplicado`,
  workflow_docstatus_earlyduplicate: `El flujo de trabajo no se puede asignar a un documento duplicado`,
  reassign_workflow: `Reasignar flujo de trabajo`,
  reassign_workflow_to_organization_users: `Reasignar flujo de trabajo a otro(s) usuario(s)`,
  approvers_required: `Se requiere aprobador`,
  reason_is_required: `Se requiere motivo`,
  reassign: `Reasignar`,
  workflow_reassigned_successfully: `Flujo de trabajo reasignado correctamente`,
  reason_max_length_validation: `El motivo no puede tener más de 100 caracteres`,
  isWorkflowApproverTriggeredOncePerDocument: `Los flujos de trabajo automatizados se ejecutan solo una vez por documento `,
  isWorkflowApproverTriggeredOncePerDocument_hover_text: `Flujos de trabajo activados por el campo "workflow approver" del documento`,
  isReviewNotAllowedAfterDocumentWorkflowApproval:
    "Deshabilitar la revisión de documentos tras la aprobación del flujo de trabajo",
  workflow_configuration: `Configuración Del Flujo De Trabajo`,
  disable_email_notification_status: `Deshabilitar el estado de notificación por correo electrónico`,
  workflow_approver_email_notification: `Habilitar notificaciones por correo electrónico para los aprobadores`,
  workflow_configurations_updated: `La configuración del flujo de trabajo se actualizó correctamente`,
  workflow_reason_maxLength: "La razón debe tener como máximo 100 caracteres",
  enablePendingApprovalReminderEmailNotification:
    "Activar recordatorios por correo electrónico para documentos pendientes de aprobación (Diariamente)",
  isApprovalReasonMandatory: "La razón de aprobación es obligatoria",
  isAssignReasonMandatory: "La razón de asignación es obligatoria",
  isRejectionReasonMandatory: "La razón de rechazo es obligatoria",
  skipWorkflowRetriggerOnDocReviewWhenPendingApproval:
    "Omitir el re-disparo del flujo de trabajo al revisar un documento cuando la aprobación está pendiente",
  skipWorkflowRetriggerOnDocReviewWhenPendingApproval_hover_text:
    "Si un documento ya está pendiente de aprobación, volver a revisarlo no volverá a disparar el flujo de trabajo.",
  disableEmailAlertOnDocApprovalRequired: `Desactivar la alerta por correo electrónico cuando se requiera la aprobación de un documento`,
  disableEmailAlertOnDocApprovalRequired_hover_text: `Si está activado, los aprobadores no recibirán una alerta por correo electrónico cuando un documento requiera su aprobación.`,
  assignment_reason: `Motivo de la asignación`,
  allowAprovalOnProcessedOrReviewedDocument: `Permitir la aprobación solo en documentos "procesados" o "revisados"`,
  allowAprovalOnProcessedOrReviewedDocument_hover_text: `los documentos con estado "need review" no serán aprobados`,
  ignoreWorkflowExecutionOnDuplicateDocument_hover_text: `Después de la extracción, si un documento se identifica como duplicado, el flujo de trabajo no se ejecutará.`,
  supplier_not_found: "Proveedor no encontrado",
  supplier_is_deleted: "Proveedor eliminado",
  workflow_reason_required:
    "Por favor proporcione una razón para asignar el flujo de trabajo",
  failed_to_fetch_supplier_approval_version_id:
    "Fallo al obtener el ID de versión de aprobación del proveedor",
  failed_to_fetch_document_workflow_approval_version_id: `Fallo al obtener la versión de aprobación del flujo de trabajo`,
  assign_workflow_when_supplier_is_created: `Asignar flujo de trabajo cuando se crea el proveedor`,
  configure_default_supplier_workflow: `Configurar flujo de trabajo predeterminado para proveedores`,
  configure_default_supplier_workflow_hover_text: `Activar flujo de trabajo cuando se crea/actualiza el proveedor (se envía una solicitud a los aprobadores configurados)`,
  bulk_workflow_first_text: `Descarga nuestra plantilla CSV de ejemplo para flujos de trabajo.`,
  upload_bulk_workflows: `Cargar flujos de trabajo masivos`,
  download_workflows: `Descargar flujos de trabajo`,
  bulk_workflow_upload: `Carga de flujos de trabajo masivos`,
  ignoreWorkflowExecutionOnDuplicateDocument: `Impedir la "asignación" o "ejecución" del flujo de trabajo en documentos duplicados.`,
  "workflow-reason-required": `Se requiere justificación`,
  workflow_not_found: `Flujo de trabajo no encontrado`,
  download_workflow: `Flujo de trabajo de descarga`,

  workflow_download_request_inprocess: `Solicitud de descarga de flujo de trabajo en proceso`,
  assign_workflow_via_template: `Asigna este documento a un rol y etapa de tu flujo de trabajo`,
  select_organization_role: `Seleccionar rol de la organización`,
  select_stage: `Seleccionar etapa`,
  role: `Rol`,
  stage: `Etapa`,
  description: `Descripción`,
  description_required: `La descripción es obligatoria`,
  organization_role_is_required: `El rol de la organización es obligatorio`,
  enter_reason: `Introduce el motivo`,
  select_approvers: `Seleccionar aprobadores`,
  reassign_to_new_approver: `Reasignar a nuevo aprobador`,
  reassign_document_workflow_subtitle: `Reasigna el flujo de trabajo de este documento a usuarios de tu organización`,
  reassign_supplier_workflow_subtitle: `Reasigna el flujo de trabajo de este proveedor a usuarios de tu organización`,
  reason_max_length_1000: `El motivo debe tener como máximo 1000 caracteres`,
  reject_document_subtitle: `Indica el motivo del rechazo del documento y, si quieres, especifica un nuevo aprobador`,
};
export default workflows;
